<template>
  <tr>
    <td>
      <v-avatar class="ma-2" color="grey lighten-2" size="38">
        <img alt="avatar" :src="member.avatar_thumb_url" />
      </v-avatar>
    </td>
    <td>{{ member.full_name }}</td>
    <td>{{ member.email }}</td>
    <td>
      <template v-if="ownerId != member.id">
        <div class="flex py-3">
          <v-select
            outlined
            required
            label="Member Role"
            :items="roleOptions"
            :loading="isChangingRole"
            :disabled="isChangingRole"
            v-model="member.group_role"
          >
          </v-select>
        </div>
      </template>

      <template v-else>
        Group Owner
      </template>
    </td>
    <td>
      <template v-if="ownerId != member.id">
        <template v-if="!member.profile_completed">
          <v-btn
            color="primary"
            :loading="isSendingInvitation"
            :disabled="isSendingInvitation"
            @click="resendInvitation"
            >Resend</v-btn
          >
        </template>

        <template v-else>
          <v-btn color="red" @click="removeMember">Remove</v-btn>
        </template>
      </template>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    ownerId: {
      type: Number,
      default: 0
    },
    groupId: {
      type: Number,
      default: 0
    },
    member: {
      type: Object
    }
  },

  data() {
    return {
      isChangingRole: false,
      isSendingInvitation: false,
      roleOptions: [
        { text: 'Student', value: 'USER' },
        { text: 'Group Leader', value: 'GROUP_LEADER' }
      ]
    }
  },

  methods: {
    changeRole(newRole, oldRole) {
      this.isChangingRole = true
      this.$api
        .post(`/groups/${this.groupId}/members/${this.member.id}/change-role`, {
          role: newRole
        })
        .then(() =>
          this.$toast('Member successfully changed role!', {
            color: 'green'
          })
        )
        .finally(() => (this.isChangingRole = false))
    },
    removeMember() {
      this.$confirm(
        `Are you sure you want to remove <strong>${
          this.member.full_name
        }</strong>?`
      ).then(res => {
        if (res) {
          this.isRemovingMember = true
          this.$api
            .post(`/groups/${this.groupId}/members/${this.member.id}/remove`)
            .then(() =>
              this.$toast('Member successfully removed!', {
                color: 'green'
              })
            )
            .finally(() => {
              this.isRemovingMember = false
              this.$emit('removed')
            })
        }
      })
    },
    resendInvitation() {
      this.isSendingInvitation = true
      this.$api
        .post(`/groups/${this.groupId}/members/${this.member.id}/resend`)
        .then(() =>
          this.$toast('Invitation successfully sent!', {
            color: 'green'
          })
        )
        .finally(() => (this.isSendingInvitation = false))
    }
  },

  watch: {
    'member.group_role': function(newVal, oldVal) {
      this.changeRole(newVal, oldVal)
    }
  }
}
</script>

<style>
.v-text-field__details {
  display: none;
}
</style>
